import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Wrench, Zap, Droplets, Flame, ArrowRight, TrendingUp } from 'lucide-react';
import { CardStats } from '@components/ui';
import { getElektrikStats } from '@mocks/materials/elektrik';
import { getSuTesisatiStats } from '@mocks/materials/suTesisati';
import { getDogalgazStats } from '@mocks/materials/dogalgaz';
import { formatCurrency } from '../components/StockIndicator';

const subCategories = [
    { key: 'elektrik', label: 'Elektrik', path: '/insaat/tesisat/elektrik', icon: Zap, color: 'bg-error', description: 'Kablo, pano ve aydınlatma takibi' },
    { key: 'su-tesisati', label: 'Su Tesisatı', path: '/insaat/tesisat/su-tesisati', icon: Droplets, color: 'bg-info', description: 'Boru, vana ve armatür takibi' },
    { key: 'dogalgaz', label: 'Doğalgaz', path: '/insaat/tesisat/dogalgaz', icon: Flame, color: 'bg-warning', description: 'Boru, kombi ve sayaç takibi' },
];

export default function TesisatMontaj() {
    const { selectedConstruction, showAllConstructions } = useSelector((state) => state.construction);
    const insaatId = showAllConstructions ? null : selectedConstruction?.id;

    const elektrikStats = getElektrikStats(insaatId);
    const suStats = getSuTesisatiStats(insaatId);
    const gazStats = getDogalgazStats(insaatId);
    const toplamMaliyet = elektrikStats.toplamMaliyet + suStats.toplamMaliyet + gazStats.toplamMaliyet;

    return (
        <div className="p-4 md:p-6 space-y-6">
            <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-xl bg-info flex items-center justify-center">
                    <Wrench size={24} className="text-white" />
                </div>
                <div>
                    <h1 className="text-2xl font-bold text-text-primary">Tesisat & Montaj</h1>
                    <p className="text-text-secondary">
                        {showAllConstructions ? 'Tüm İnşaatlar' : selectedConstruction?.name || 'Seçili proje yok'}
                    </p>
                </div>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                <CardStats title="Elektrik Kalemleri" value={`${elektrikStats.toplamKalem}`} icon={Zap} color="error" />
                <CardStats title="Su Tesisatı" value={`${suStats.toplamKalem}`} icon={Droplets} color="info" />
                <CardStats title="Doğalgaz" value={`${gazStats.toplamKalem}`} icon={Flame} color="warning" />
                <CardStats title="Toplam Maliyet" value={formatCurrency(toplamMaliyet)} icon={TrendingUp} color="primary" />
            </div>

            <div>
                <h2 className="text-lg font-semibold text-text-primary mb-4">Malzeme Kategorileri</h2>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    {subCategories.map((cat) => {
                        const Icon = cat.icon;
                        return (
                            <Link key={cat.key} to={cat.path}
                                className="group bg-bg-secondary rounded-xl p-5 border border-border-light hover:shadow-lg hover:border-primary/30 transition-all">
                                <div className="flex items-start justify-between">
                                    <div className="flex items-center gap-3">
                                        <div className={`w-12 h-12 rounded-xl ${cat.color} flex items-center justify-center`}>
                                            <Icon size={24} className="text-white" />
                                        </div>
                                        <div>
                                            <h3 className="font-semibold text-text-primary group-hover:text-primary transition-colors">{cat.label}</h3>
                                            <p className="text-sm text-text-muted mt-1">{cat.description}</p>
                                        </div>
                                    </div>
                                    <ArrowRight size={20} className="text-text-muted group-hover:text-primary transition-colors" />
                                </div>
                            </Link>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}
